import React, { useState, useMemo } from 'react';
import { IWatchesRanges, regexForRanges } from '../../watchesState/watchesContext';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import style from './AdminWatches.module.scss';

interface IAdminWatches {
	changeAdminWatchesTableRanges(rangeId: string, range: string): void;
	adminWatchesTableRanges: IWatchesRanges[];
}

const AdminWatches: React.FC<IAdminWatches> = ({ changeAdminWatchesTableRanges, adminWatchesTableRanges }) => {
	const [validValue, setValidValue] = useState<string>('');
	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: 'Enter table ranges. Example: 1-15;20-25' },
			() => ({
				validator(_, value) {
					if (value && !value.match(regexForRanges)) {
						return Promise.reject(new Error('Separators cannot be repeated. Example: 1-15;20-25'));
					}
					return Promise.resolve();
				},
			}),
		],
		[],
	);

	const handleChange = (rangeId: string, value: string) => {
		if (/^[0-9.;\\-]+$/g.test(value) || value === '') {
			setValidValue(value);
			changeAdminWatchesTableRanges(rangeId, value);
			return value;
		}
		changeAdminWatchesTableRanges(rangeId, validValue);
		return validValue;
	};

	const adminWatchesTableRangesList = useMemo(() => {
		return adminWatchesTableRanges.map((el) => (
			<FormInput
				testId={`WatchField-${el.id}`}
				name={el.id}
				label="Table range admin watches"
				onChange={(value) => handleChange(el.id, value)}
				validationRules={validationRules}
				placeholder="Enter by example: 1-15;20-25"
				key={el.id}
			/>
		));
	}, [adminWatchesTableRanges]);

	return <div className={style.container}>{adminWatchesTableRangesList}</div>;
};

export default React.memo(AdminWatches);
